import React from 'react';
import PropTypes from 'prop-types';

import 'src/app/components/FeedbackMessage.scss';


const FeedbackMessage = React.forwardRef(({ template, icon, children, onClick }, ref) => (
  <div styleName={ `feedback-message feedback-message--${template}` }
       ref={ ref }
  >
    <span styleName="feedback-message__lead-icon">
      {icon}
    </span>

    <div data-test="text-feedback-message"
         styleName="feedback-message__description"
    >
      {children}
    </div>

    <button type="button"
            styleName="feedback-message__close-button"
            onClick={ onClick }
    >
      close
    </button>
  </div>
));


FeedbackMessage.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  template: PropTypes.string.isRequired
};


export default FeedbackMessage;
